import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DeviceBehfaFilterGroupService } from 'src/app/Service/DeviceBehfaFilterGroup/DeviceBehfaFilterGroup.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-DeviceBehfaFilterGroupList',
  templateUrl: './DeviceBehfaFilterGroupList.component.html',
  styleUrls: ['./DeviceBehfaFilterGroupList.component.scss']
})
export class DeviceBehfaFilterGroupListComponent implements OnInit {

  Token: string = ""
  Filter_Title: string = ""
  Filter_Fullname: string = ""
  page: number = 0;
  Procssing: boolean = false

  modalRef_Delete: any;

  constructor(
    private DeviceBehfaFilterGroup_Service: DeviceBehfaFilterGroupService,
    private Alertify_Service: AlertifyService,
    private modalService: BsModalService,
    private Nav_Service: NavService,
  ) { }


  DataList_DeviceBehfaFilterGroup: Array<General_Interface> = []
  DeviceBehfaFilterGroup_Record_Delete: General_Interface = Empty_General_Interface()

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token, 2224).subscribe(
      data => {
        this.ReadData_DeviceBehfaFilterGroup()
      }
      , error => {
        localStorage.clear()
        location.reload();
      }
    )

  }

  ReadData_DeviceBehfaFilterGroup() {
    this.Procssing = true
    this.DeviceBehfaFilterGroup_Service.GetRecord(this.Token,this.Filter_Fullname).subscribe(
      data => {
        this.DataList_DeviceBehfaFilterGroup = data
        this.Procssing = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }


  //#region DeviceBehfaFilterGroup Form

  Selected_DeviceBehfaFilterGroup_Record: General_Interface
  Selected_DeviceBehfaFilterGroup_Record_Switcher: string = 'List'
  Set_List_DeviceBehfaFilterGroup_View() {
    this.ReadData_DeviceBehfaFilterGroup()
    this.Selected_DeviceBehfaFilterGroup_Record_Switcher= 'List'
  }

  Set_Form_DeviceBehfaFilterGroup_View(item:General_Interface,Switcher:string) {
    this.Selected_DeviceBehfaFilterGroup_Record = item
    this.Selected_DeviceBehfaFilterGroup_Record_Switcher = Switcher
  }

  Set_Form_DeviceBehfaFilterGroup_View_Add() {
    this.Selected_DeviceBehfaFilterGroup_Record = Empty_General_Interface()
    this.Selected_DeviceBehfaFilterGroup_Record_Switcher = 'Form'
  }

  //#endregion

  //#region Delete

  Delete(){
    this.modalRef_Delete.hide()

    this.DeviceBehfaFilterGroup_Service.Delete(this.Token,this.DeviceBehfaFilterGroup_Record_Delete.id).subscribe(
      data=>{
        this.Alertify_Service.SuccessMessage("Deleted successfully.")
        this.ReadData_DeviceBehfaFilterGroup()
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  DeleteModal(template: TemplateRef<any>,Record) {
    this.DeviceBehfaFilterGroup_Record_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }

  //#endregion

  Change_Filter() {
    this.page = 0
  }

}
